import React, { useState } from "react";
import MaterialTextFieldComponent from "../../../../components/textField/MaterialTextFieldCmp";
import Grid from "@mui/material/Grid";
import PriceFeildComponent from "../../../../components/priceFeild/priceFeildComponent";
import createCache from "@emotion/cache";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
const theme2 = createTheme({
  direction: "rtl",
});
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
export default function DynamicActionForm(props: any) {
  const [inputs, setInputs] = useState(props.inputs);
  const updateInput = (index: number, e: any) => {
    let newInputs = [...props.inputs];
    newInputs[index].data = e.target.value.replace(/,/g, "");
    setInputs(newInputs);
    props.updateTab(props.tabIndex, newInputs);
  };

  const numberHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key !== 8 && key !== 46) {
      event.preventDefault();
    }
  };

  return (
    <div className="row">
      {inputs.map((item: any, index: number) => {
        switch (item.inputType) {
          case "Note":
            return (
              <>
                <br />
                <Grid container xs={10} columns={{ xs: 4, sm: 8, md: 12 }}>
                  <Grid
                    item
                    xs={10}
                    style={{ paddingLeft: "1vh" }}
                    width={"400px"}
                  >
                    {/* <div className="col-12 col-lg-6" style={{ maxWidth: '40%' }}> */}
                    <span
                      className="dynamicActiontitle"
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    ></span>
                    <MaterialTextFieldComponent
                      key={index}
                      autoFocus={index == 0}
                      // helperText={!touched.mobileNumber ? errors.mobileNumber : ""}
                      // error={!touched.mobileNumber && Boolean(errors.mobileNumber)}
                      // label={title2}
                      placeHolder={"توضیحات"}
                      required={true}
                      type="text"
                      value={item.data}
                      onChange={(e: any) => updateInput(index, e)}
                      name={item.name}
                      id={item.name}
                      error={item.isRequired}
                    />
                    {/* </div> */}
                  </Grid>
                </Grid>
              </>
            );
          case "DropDown":
            return <></>;
          case "RialBox":
            return (
              <>
                <CacheProvider value={cacheRtl}>
                  <ThemeProvider theme={theme2}>
                    <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}>
                      <Grid
                        item
                        xs={12}
                        style={{ paddingLeft: "1vh" }}
                        maxWidth={"600px"}
                        display={"flex"}
                        alignItems={"center"}
                        // gap={"20px"}
                        // position={"relative"}
                        textAlign={"left"}
                      >
                        {/* <div className="col-12 col-lg-6" style={{ maxWidth: '40%' }}> */}
                        <Box
                          minWidth={"300px"}
                          maxWidth={"300px"}
                          minHeight={"50px"}
                        >
                          <PriceFeildComponent
                            onKeyDown={numberHandleKeyDown}
                            key={index}
                            label={`${item.title}(ریال)*`}
                            placeHolder={"(ریال) مبلغ اعتبار*"}
                            required={true}
                            value={item.data.replace(
                              /\B(?=(\d{3})+(?!\d))/g,
                              ","
                            )}
                            onChange={(e: any) => updateInput(index, e)}
                            id={item.name}
                            name={item.name}
                            error={props.inputsError}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </ThemeProvider>
                </CacheProvider>
              </>
            );
          default:
            return (
              <MaterialTextFieldComponent
                key={index}
                autoFocus={true}
                label={item.title}
                placeHolder={item.title}
                required={true}
                type="text"
                value={item.data}
                // onChange={handleChange}
                name={item.name}
                id={item.name}
              />
            );
        }
      })}
    </div>
  );
}
